import React from 'react';

import { useFreecodeContextData, useFreecodeContextRun } from 'hooks/useContext';
import { Table, TableHead, TableBody, TableHeader, TableData } from './styles';
import { categories } from 'constants/tests';

export default function Score() {
  const { test } = useFreecodeContextData();
  const { runResponse, levelToRun } = useFreecodeContextRun();

  const isExercise = test.category === categories.EXERCISE.category;

  return (
    <Table>
      <TableHead>
        <tr>
          <TableHeader>Level Name</TableHeader>
          <TableHeader>Score</TableHeader>
          <TableHeader>Time</TableHeader>
        </tr>
      </TableHead>
      <TableBody>
        {(!isExercise || levelToRun === runResponse?.levelToRun) &&
          runResponse?.levelResults?.map?.((levelResult, index) => (
            <tr key={index}>
              <TableData>{`Level ${(isExercise ? levelToRun : index) + 1} :: ${levelResult.name}`}</TableData>
              <TableData>{`${levelResult.scores?.[0]} / ${levelResult.maxScore}`}</TableData>
              <TableData>{`${levelResult.solutionTimes?.[0]} ms`}</TableData>
            </tr>
          ))}
      </TableBody>
    </Table>
  );
}
